// app/AnalyticsWrapper.tsx
'use client';

import dynamic from 'next/dynamic';
const AnalyticsTracker = dynamic(() => import('./analytics-tracker'), { ssr: false });

export default function AnalyticsWrapper() {
  return <AnalyticsTracker />;
}
